import JSZip from "jszip";
import { Template } from "types/template";

export
  const extractTemplateFields = async (template: Template): Promise<string[]> => {
    try {
      if (!template.fileUrl) {
        console.error("A sablon dokumentumnak nincs file URL-je");
        return [];
      }

      const response = await fetch(template.fileUrl);

      if (!response.ok) {
        throw new Error(`Nem sikerült letölteni a dokumentumot: ${response.status} ${response.statusText}`);
      }

      const templateBuffer = await response.arrayBuffer();
      const zip = new JSZip();
      const docx = await zip.loadAsync(templateBuffer);

      // Összes dokumentum xml fájl, amiben placeholderek lehetnek
      const xmlFiles = Object.keys(docx.files).filter(fileName =>
        fileName.startsWith("word/") &&
        (fileName.endsWith(".xml") || fileName.includes("document.xml") ||
          fileName.includes("header") || fileName.includes("footer") ||
          fileName.includes("footnotes") || fileName.includes("endnotes") ||
          fileName.includes("settings"))
      );

      const placeholders = new Set<string>();
      
      // Mindig biztosítsuk, hogy a Fizetési határidő mező elérhető legyen
      if (template.type === 'quotation') {
        placeholders.add('Fizetési határidő');
      }

      // Végigmegyünk minden lehetséges XML fájlon
      for (const fileName of xmlFiles) {
        const content = await docx.file(fileName)?.async("text");
        if (!content) continue;

        // Kétféle regex a különböző formátumú placeholderek megtalálására
        // 1. Alap placeholder formátum: {{valami}}
        const basicMatches = content.match(/\{\{([^{}]+)\}\}/g) || [];

        // 2. Word XML-be ágyazott placeholderek, ahol a {{ és }} között lehet XML tag
        const complexMatches = content.match(/\{\{([^{}]*(?:\{\{[^{}]*\}\})?[^{}]*)\}\}/g) || [];

        const allMatches = [...basicMatches, ...complexMatches];

        allMatches.forEach(match => {
          try {
            // Kivesszük a {{}} közötti részt
            let placeholder = match.replace(/^\{\{|\}\}$/g, "").trim();

            // Tisztítjuk a placeholder-t az XML tagoktól
            placeholder = placeholder.replace(/<[^>]+>/g, " ").trim();
            placeholder = placeholder.replace(/\s+/g, " "); // Több space helyett egy

            // Kiszűrjük az üres vagy nem megfelelő placeholdereket
            if (
              placeholder.length > 0 &&
              !placeholder.includes('<') &&
              !placeholder.includes('>') &&
              !placeholder.includes('w:') &&
              !placeholder.includes('xml:') &&
              !/^\d+$/.test(placeholder) // Nem csak számok
            ) {
              placeholders.add(placeholder);
            }
          } catch (e) {
            console.warn("Hiba a placeholder feldolgozása során:", e);
          }
        });
      }

      // Ha üres a placeholders, próbáljunk másik módszert
      if (placeholders.size === 0 || (placeholders.size === 1 && template.type === 'quotation' && placeholders.has('Fizetési határidő'))) {
        // Alapvető dokumentum tartalom
        const contentXml = await docx.file("word/document.xml")?.async("text");
        if (contentXml) {
          // Ha a Word dokumentumban van egy egyedi elválasztó a placeholderek jelölésére
          // például: {{placeholder}}
          const customMatches = contentXml.match(/\{\{([^{}]+)\}\}/g) || [];

          customMatches.forEach(match => {
            const placeholder = match.slice(2, -2).trim();
            if (placeholder.length > 0) {
              placeholders.add(placeholder);
            }
          });
        }
      }

      // Rendezzük a mezőket abc sorrendbe
      return Array.from(placeholders).sort();

    } catch (error) {
      console.error("Hiba történt a sablon dokumentum feldolgozása közben:", error);
      return [];
    }
  };